import { ArrowLeft01Icon } from '@hugeicons/core-free-icons';
import type { IconSvgElement } from '@hugeicons/react-native';
import { type NavigationProp } from '@react-navigation/core';
import { useGlobalSearchParams, useNavigation } from 'expo-router';
import React from 'react';
import { View } from 'react-native';
import { defaultBack } from '../utils/navigation';
import { IconButton } from './IconButton';

type Props<T = NavigationProp<ReactNavigation.RootParamList>> = {
  icon?: IconSvgElement;
  onPress?: (
    params: Record<string, string | string[]>,
    navigation: T,
  ) => void | Promise<void>;
  loading?: boolean;
  size?: 'small' | 'medium' | 'large';
};

export function HeaderButton<T>({
  icon = ArrowLeft01Icon,
  onPress = defaultBack(),
  loading,
  size,
}: Props<T>) {
  const params = useGlobalSearchParams<Record<string, string | string[]>>();
  const navigation: T = useNavigation();

  return (
    <View>
      <IconButton
        icon={icon}
        onPress={() => {
          void onPress(params, navigation);
        }}
        size={size || 'small'}
        loading={loading}
      />
    </View>
  );
}
